import * as React from 'react';
import Tippy from '@tippyjs/react/headless';
import { Id } from '../../utils/ids.js';
import { addClass, Bem } from '../../utils/css.js';
import { Placement } from '../../constants.js';
import './Tooltip.scss.js';

const bem = Bem.create("vai-tooltip");
const TooltipBox = React.forwardRef((props, ref) => {
  const { htmlId, dataTa, children, className, ...rest } = props;
  const id = Id.create(htmlId, ["tooltip"]);
  const tooltipClasses = addClass(bem.block(), className);
  return /* @__PURE__ */ React.createElement("div", {
    ref,
    id: id.toString(),
    "data-ta": dataTa,
    className: tooltipClasses,
    ...rest
  }, children);
});
const TooltipArrow = React.forwardRef(function TooltipArrow2(props, ref) {
  const { dataTa = "vai-tooltip-arrow", visible, className, ...rest } = props;
  const tooltipArrowClasses = addClass(bem.element("arrow")(), className);
  return visible ? /* @__PURE__ */ React.createElement("div", {
    ref,
    "data-ta": dataTa,
    className: tooltipArrowClasses,
    ...rest
  }) : null;
});
function Tooltip(props) {
  const {
    htmlId,
    dataTa = "vai-tooltip",
    children,
    triggerElement,
    className,
    placement = Placement.Bottom,
    arrow = false,
    trigger = "mouseenter focus",
    delay = [100, 200],
    triggerRef,
    visible,
    config,
    ...rest
  } = props;
  const id = Id.create(htmlId, ["tooltip"]);
  const triggerMode = trigger !== null || trigger !== void 0 ? trigger : "mouseenter focus";
  const placementMode = placement !== null || placement !== void 0 ? placement : "bottom";
  return /* @__PURE__ */ React.createElement(Tippy, {
    trigger: triggerMode,
    placement: placementMode,
    delay,
    reference: triggerRef,
    visible,
    offset: [0, 8],
    render: (attrs) => /* @__PURE__ */ React.createElement(TooltipBox, {
      htmlId: id.toHtmlId(),
      tabIndex: -1,
      className,
      dataTa,
      ...rest,
      ...attrs
    }, children, /* @__PURE__ */ React.createElement(TooltipArrow, {
      visible: arrow,
      "data-popper-arrow": true
    })),
    ...config
  }, triggerElement);
}

export { Tooltip };
